module.exports = __webpack_public_path__ + "static/media/yearlytext.2e02e921.png";